module.exports = __webpack_public_path__ + "assets/img/Guide02.aa6e749e.png";